import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToolkitModule } from '@core';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { PopoverModule } from 'ngx-bootstrap/popover';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        ToolkitModule,
        PaginationModule.forRoot(),
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        FontAwesomeModule,
        NgSelectModule,
        PopoverModule.forRoot()
    ],
    exports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        ToolkitModule,
        PaginationModule,
        BsDatepickerModule,
        BsDropdownModule,
        FontAwesomeModule,
        NgSelectModule,
        PopoverModule
    ]
})
export class SharedCommonModule {
}
